import { DateTime } from 'luxon';
import { Instance, types } from 'mobx-state-tree';

import { getClientGradeBooks } from '@common/api/clientGradebook';
import PeriodModel from '@common/models/PeriodModel';

import ClientGradeBook, { IClientGradeBookModel } from './ClientGradeBook';

const ClientGradeBooks = types
	.compose(
		PeriodModel,
		types.model({
			data: types.optional(types.array(ClientGradeBook), []),
			is_enabled: false,
		}),
	)
	.named('ClientGradeBooks')
	.views((self) => ({
		get hasGrades() {
			return self.data.length > 0;
		},
		get groupLessonsByDayWithEmptyDates() {
			const groupedLessons = self.data.reduce((acc, lesson) => {
				const date = lesson.gb_date;
				if (!acc[date]) {
					acc[date] = [];
				}
				acc[date].push(lesson);
				return acc;
			}, {});

			return Object.fromEntries(
				Object.entries(groupedLessons).sort(
					([dateA], [dateB]) =>
						DateTime.fromISO(dateA).valueOf() - DateTime.fromISO(dateB).valueOf(),
				),
			) as Record<string, IClientGradeBookModel[]>;
		},
		get groupLessonsByDay() {
			const allDays: any = {};
			const currentDate = new Date(self.period_start);
			const endDate = new Date(self.period_end);

			while (currentDate <= endDate) {
				const dateString = currentDate.toISOString().split('T')[0];
				allDays[dateString] = [];
				currentDate.setDate(currentDate.getDate() + 1);
			}

			return self.data.reduce((acc, lesson) => {
				const date = lesson.gb_date;
				if (acc[date] && lesson.schedule_lesson.schedule_program) {
					acc[date].push(lesson);
				}
				return acc;
			}, allDays);
		},
	}))
	.views((self) => ({
		get groupLessonsByDayWithGaps() {
			const grouped = self.groupLessonsByDay;

			return Object.entries(grouped).reduce(
				(acc: Record<string, IClientGradeBookModel[]>, [date, lessons]: any) => {
					// Сортуємо уроки по order_id
					const orderedLessons = lessons
						.slice() // робимо копію масиву
						.sort((a: any, b: any) => a.schedule_lesson.order_id - b.schedule_lesson.order_id);

					const gaps = Math.max(8 - orderedLessons.length, 0);

					// Додаємо уроки і, якщо потрібно, заповнюємо пропуски null до 8
					const filledLessons = [...orderedLessons, ...Array(gaps).fill(null)];

					acc[date] = filledLessons;
					return acc;
				},
				{},
			);
		},
	}))
	.actions((self) => ({
		_fetch: (query: any) =>
			getClientGradeBooks({
				period_start: self.period_start,
				period_end: self.period_end,
				...query,
			}),
	}));

export default ClientGradeBooks;

export interface IClientGradeBooksModel extends Instance<typeof ClientGradeBooks> {}
